import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetAllVideosInterface {
  status: string;
}

export const useGetAllVideos = () => {
  const mutate = useMutation(({ status }: GetAllVideosInterface) => {
    return get(`/media-api/get_all_creators_videos/${status}`);
  });

  return mutate;
};

export default useGetAllVideos;
